import React from 'react';

const Input = ({data, index, state, updateState}) => {
  return (
  <div className='field'>
    <label dangerouslySetInnerHTML={{ __html: data.label }}></label> 
    <input 
    id={index} 
    placeholder={data.placeholder} 
    className={data.class} 
    value={state}
    onChange={(e) => updateState(e)} />
  </div>)
}

export default React.memo(Input);